import "./App.css";
import React, { useEffect, useState } from "react";
import { BrowserRouter as Router, Route, Routes } from "react-router-dom";
import {
  FormUpdateManual,
  HomePage,
  ReportView,
  DetailMDR,
  Login,
  LoadXML,
  LoadSupplierXLSX,
  Form,
  Alerts,
  ProfileUser,
  Verify,
  SelectRecoveryMethod,
  GmailRecovery,
  AuthenticatorGoogle,
  FormVarMatriz,
  RecoverPassword,
  Report,
  DetailIncomeAndExpenses,
  AllPDF,
  DetailTerrorist,
  Bundles,
} from "./views";
import ABMDetail from "./components/ABM/ABMDetail/ABMDetail";
import ABMDetailCompanyamebo from "./components/Company/ABMCompany/ABMDetailCompany/ABMDetailCompany.jsx";
import ProtectedRoute from "./components/Routes/ProtectedRoute";
import Error404 from "./components/Error404/Error404";
import {
  HomePageL,
  ReportViewL,
  ProfileUserL,
  AllPDFL,
  LoadXMLL,
  LoadSupplierXLSXlealtad,
  FormVarMatrizL,
  FormUpdateManualL,
  FormL,
  DetailTerroristL,
  DetailMDRL,
  DetailIncomeAndExpensesL,
  ReportL,
  AlertsL,
  UploadBundlesLealtad,
} from "./Lealtad/views";
import ABMDetailL from "./Lealtad/components/ABM/ABMDetail/ABMDetail";
import ABMDetailCompany from "./Lealtad/components/Company/ABMCompany/ABMDetailCompany/ABMDetailCompany.jsx";
import { useLocalStorage } from "./utils/useLocalStorage/useLocalStorage";
/*Proveedor y Comercializador*/
//import ArchivePersonHuman from "./viewsProveedor/ArchivePersonHuman/ArchivePersonHuman.jsx";
import IndexProveedorComercializador from "./viewsProveedor/IndexProveedorComercializador/IndexProveedorComercializador.jsx";
import IndexProveedor from "./viewsProveedor/IndexProveedor/IndexProveedor.jsx";
import IndexProvAdmin from "./viewsProveedor/IndexProvAdmin/IndexProvAdmin.jsx";
import FormProvComercializador from "./viewsProveedor/FormProvComercializador/FormProvComercializador.jsx";
import FormProveedor from "./viewsProveedor/FormProveedor/FormProveedor.jsx";
import TermsConditionSignature from "./viewsProveedor/TermsConditionSignature/TermsConditionSignature.jsx";
import FormAdminProv from "./viewsProveedor/FormAdminProv/FormAdminProv.jsx";
import ListProvAdmin from "./viewsProveedor/ListProvAdmin/ListProvAdmin.jsx";
import ListUserProv from "./viewsProveedor/ListUserProvs/ListUserProv.jsx";
import ListProv from "./viewsProveedor/ListProv/ListProv.jsx";
import ListSaleProv from "./viewsProveedor/ListSalesProveedor/ListSalesProv.jsx";
import ListaSaleComercializador from "./viewsProveedor/ListSaleComercializador/ListSalesComer.jsx";
import ListComerSignature from "./viewsProveedor/ListComerSignature/ListComerCsignature.jsx";
//PROVEEDOR Y COMERCIALIZADOR DE LEALTAD
import TermsConditionSignatureLealtad from "./viewsProveedorLealtad/TermsConditionSignatureLealtad/TermsConditionSignatureLealtad.jsx";
import IndexProveedorComercializadorLealtad from "./viewsProveedorLealtad/IndexProveedorComercializadorLealtad/IndexProveedorComercializadorLealtad.jsx";
import IndexProveedorLealtad from "./viewsProveedorLealtad/IndexProveedorLealtad/IndexProveedor.jsx";
import IndexProvAdminLealtad from "./viewsProveedorLealtad/IndexProvAdminLealtad/IndexProvAdmin.jsx";
import FormProvComercializadorLealtad from "./viewsProveedorLealtad/FormProvComercializadorLealtad/FormProvComercializadorLealtad.jsx";
import FormProveedorLealtad from "./viewsProveedorLealtad/FormProveedorLealtad/FormProveedorLealtad.jsx";
import FormAdminProvLealtad from "./viewsProveedorLealtad/FormAdminProvLealtad/FormAdminProvLealtad.jsx";
import ListProvAdminLealtad from "./viewsProveedorLealtad/ListProvAdmin/ListProvAdmin.jsx";
import ListUserProvLealtad from "./viewsProveedorLealtad/ListUserProvs/ListUserProv.jsx";
import ListProvLealtad from "./viewsProveedorLealtad/ListProv/ListProv.jsx";
import ListProveedoresLealtad from "./viewsProveedorLealtad/ListProveedoresLealtad/ListProveedoresLealtad.jsx";
import ListProveedores from "./viewsProveedor/ListProveedores/ListProveedores.jsx";
import ListSaleProvLealtad from "./viewsProveedorLealtad/ListSalesProveedor/ListSalesProveedor.jsx";
import ListSaleComercializador from "./viewsProveedorLealtad/ListSaleComercializador/ListSalesComer.jsx";
import ListComerSignatureLealtad from "./viewsProveedorLealtad/ListComerSignatureLealtad/ListComerSignatureLealtad.jsx";

function App() {
  const [adminType, setAdminType] = useLocalStorage("adminType", "TresDeJunio");
  const [isLoading, setIsLoading] = useState(true);

  const handleAdminTypeChange = (newAdminType) => {
    setAdminType(newAdminType);
  };

  useEffect(() => {
    if (adminType) {
      setIsLoading(false);
    }
  }, [adminType]);

  // Si aún estamos cargando el tipo de administrador, mostramos un mensaje de carga
  if (isLoading) {
    return <div>Cargando...</div>;
  }

  return (
    <Router>
      <div className="App">
        <Routes>
          <Route
            path="/"
            element={<Login onAdminTypeChange={handleAdminTypeChange} />}
          />
          <Route
            path="/selectRecoveryMethod"
            element={<SelectRecoveryMethod />}
          />
          <Route path="/gmailRecovery" element={<GmailRecovery />} />
          <Route
            path="/authenticatorGoogle"
            element={<AuthenticatorGoogle />}
          />
          <Route path="/verify" element={<Verify />} />
          <Route path="/recover/:token" element={<RecoverPassword />} />
          <Route path="/" element={<ProtectedRoute />}>
            <Route path="/inicio" element={<HomePage />} />
            <Route path="/cargar" element={<LoadXML />} />
            <Route path="/carga-proveedores" element={<LoadSupplierXLSX />} />
            <Route path="/reportes" element={<Report />} />
            <Route path="/informe" element={<ReportView />} />
            <Route path="/informe/actualizar" element={<FormUpdateManual />} />
            <Route path="/perfil" element={<ProfileUser />} />
            <Route path="/crear-relacion" element={<Form />} />
            <Route path="/alertas" element={<Alerts />} />
            <Route path="/detailMDR" element={<DetailMDR />} />
            <Route path="/detalle/" element={<ABMDetail />} />
            <Route
              path="/detalle-company/"
              element={<ABMDetailCompanyamebo />}
            />
            <Route
              path="/informe/terrorismo-pdf"
              element={<DetailTerrorist />}
            />
            <Route
              path="/detalle-ingresos-egresos"
              element={<DetailIncomeAndExpenses />}
            />
            <Route path="/edit-matriz" element={<FormVarMatriz />} />
            <Route path="informe/imprimir-pdf" element={<AllPDF />} />
            <Route path="Legajos" element={<Bundles />} />
            <Route path="*" element={<Error404 />} />
            {adminType === "Amece" && (
              <>
                <Route path="/inicio-lealtad" element={<HomePageL />} />
                <Route path="/lealtad/cargar" element={<LoadXMLL />} />
                <Route
                  path="/lealtad/cargar-proveedores"
                  element={<LoadSupplierXLSXlealtad />}
                />
                <Route path="/lealtad/reportes" element={<ReportL />} />
                <Route path="/lealtad/informe" element={<ReportViewL />} />
                <Route
                  path="/lealtad/informe/actualizar"
                  element={<FormUpdateManualL />}
                />
                <Route path="/lealtad/perfil" element={<ProfileUserL />} />
                <Route path="/lealtad/crear-relacion" element={<FormL />} />
                <Route path="/lealtad/alertas" element={<AlertsL />} />
                <Route path="/lealtad/detailMDR" element={<DetailMDRL />} />
                <Route path="/lealtad/detalle/" element={<ABMDetailL />} />
                <Route
                  path="/lealtad/detalle-company/"
                  element={<ABMDetailCompany />}
                />
                <Route
                  path="/lealtad/informe/terrorismo-pdf"
                  element={<DetailTerroristL />}
                />
                <Route
                  path="/lealtad/detalle-ingresos-egresos"
                  element={<DetailIncomeAndExpensesL />}
                />
                <Route
                  path="/lealtad/edit-matriz"
                  element={<FormVarMatrizL />}
                />
                <Route
                  path="/lealtad/informe/imprimir-pdf"
                  element={<AllPDFL />}
                />
                <Route
                  path="/lealtad/Legajos"
                  element={<UploadBundlesLealtad />}
                />
                <Route path="*" element={<Error404 />} />
              </>
            )}
            {adminType === "Comercializador" && (
              <>
                <Route
                  path="/portal-comercializadores/inicio"
                  element={<IndexProveedorComercializador />}
                />
                <Route
                  path="/portal-comercializadores/mis-ventas"
                  element={<ListProv />}
                />
                <Route
                  path="/portal-comercializadores/completar-datos"
                  element={<FormProvComercializador />}
                />
                <Route
                  path="/portal-comercializadores/termscondicionsignature"
                  element={<TermsConditionSignature />}
                />
                <Route
                  path="/portal-comercializadores/mis-facturas"
                  element={<ListaSaleComercializador />}
                />
                <Route path="*" element={<Error404 />} />
              </>
            )}
            {adminType === "Proveedor" && (
              <>
                <Route
                  path="/portal-proveedor/inicio"
                  element={<IndexProveedor />}
                />
                <Route
                  path="/portal-proveedor/completar-datos"
                  element={<FormProveedor />}
                />
                <Route
                  path="/portal-proveedor/mis-facturas"
                  element={<ListSaleProv />}
                />
                <Route path="*" element={<Error404 />} />
              </>
            )}
            {adminType === "SupplierAdmin" && (
              <>
                <Route
                  path="/portal-admin-proveedor/inicio"
                  element={<IndexProvAdmin />}
                />
                <Route
                  path="/portal-admin-proveedor/completar-datos"
                  element={<FormAdminProv />}
                />
                <Route
                  path="/portal-admin-proveedor/todas-las-ventas"
                  element={<ListProvAdmin />}
                />
                <Route
                  path="/portal-admin-proveedor/lista-comercializadores"
                  element={<ListUserProv />}
                />
                <Route
                  path="/portal-admin-proveedor/lista-proveedores"
                  element={<ListProveedores />}
                />
                {/* NUEVO */}
                <Route
                  path="/portal-admin-proveedor/Descarga-pdf"
                  element={<ListComerSignature />}
                />
                {/* ------*/}
                <Route path="*" element={<Error404 />} />
              </>
            )}
            {adminType === "ComercializadorAmece" && (
              <>
                <Route
                  path="/portal-comercializadores-lealtad/inicio"
                  element={<IndexProveedorComercializadorLealtad />}
                />
                <Route
                  path="/portal-comercializadores-lealtad/mis-ventas"
                  element={<ListProvLealtad />}
                />
                <Route
                  path="/portal-comercializadores-lealtad/completar-datos"
                  element={<FormProvComercializadorLealtad />}
                />
                <Route
                  path="/portal-comercializadores-lealtad/termscondicionsignature"
                  element={<TermsConditionSignatureLealtad />}
                />
                <Route
                  path="/portal-comercializadores-lealtad/mis-facturas"
                  element={<ListSaleComercializador />}
                />
                <Route path="*" element={<Error404 />} />
              </>
            )}
            {adminType === "ProveedorAmece" && (
              <>
                <Route
                  path="/portal-proveedor-lealtad/inicio"
                  element={<IndexProveedorLealtad />}
                />
                <Route
                  path="/portal-proveedor-lealtad/completar-datos"
                  element={<FormProveedorLealtad />}
                />
                <Route
                  path="/portal-proveedor-lealtad/mis-facturas"
                  element={<ListSaleProvLealtad />}
                />
                <Route path="*" element={<Error404 />} />
              </>
            )}
            {adminType === "SupplierAdminAmece" && (
              <>
                <Route
                  path="/portal-admin-proveedor-lealtad/inicio"
                  element={<IndexProvAdminLealtad />}
                />
                <Route
                  path="/portal-admin-proveedor-lealtad/completar-datos"
                  element={<FormAdminProvLealtad />}
                />
                <Route
                  path="/portal-admin-proveedor-lealtad/todas-las-ventas"
                  element={<ListProvAdminLealtad />}
                />
                <Route
                  path="/portal-admin-proveedor-lealtad/lista-comercializadores"
                  element={<ListUserProvLealtad />}
                />
                <Route
                  path="/portal-admin-proveedor-lealtad/lista-proveedores"
                  element={<ListProveedoresLealtad />}
                />
                {/* NUEVO */}
                <Route
                  path="/portal-admin-proveedor-lealtad/Descarga-pdf"
                  element={<ListComerSignatureLealtad />}
                />
                {/* ------*/}
                <Route path="*" element={<Error404 />} />
              </>
            )}
          </Route>
        </Routes>
      </div>
    </Router>
  );
}

export default App;
